export default "__VITE_ASSET___qaZK25V__"